import {Link, NavLink, useLocation} from "react-router-dom";
import {Fragment} from "react";
import {useAppContext} from "../../../contexts/AppContext";
import {useNavContext} from "../../../contexts/NavContext";
import {buildCrumbs, buildTabs} from "../../../navigation/navConfig";
import styles from "./SubNav.module.css";

export const SubNav = () => {
    const location = useLocation();
    const {settlements, companies} = useAppContext();
    const {tabMarkers} = useNavContext();

    const crumbs = buildCrumbs(location.pathname, {settlements, companies});
    const tabs = buildTabs(location.pathname);

    // Началната страница няма контекст — Ред 2 не се рендерира.
    if (crumbs.length === 0) return null;

    return (
        <div className={styles.subNav}>
            <nav className={styles.crumbs} aria-label="breadcrumb">
                {crumbs.map((crumb, i) => (
                    <Fragment key={i}>
                        {i > 0 && <span className={styles.sep}>›</span>}
                        {crumb.to
                            ? <Link className={styles.crumbLink} to={crumb.to}>{crumb.label}</Link>
                            : <span className={styles.crumbCurrent}>{crumb.label}</span>}
                    </Fragment>
                ))}
            </nav>

            {tabs.length > 0 && (
                <div className={styles.tabs}>
                    {tabs.map(tab => {
                        const marker = tabMarkers[tab.key];
                        return (
                            <NavLink
                                key={tab.key}
                                to={tab.to}
                                end
                                title={marker ? marker.title : undefined}
                                className={({isActive}) =>
                                    `${styles.tab} ${isActive ? styles.tabActive : ''} ${marker ? styles[`tone_${marker.tone}`] : ''}`.trim()
                                }
                            >
                                {tab.label}
                                {/* Н4: маркерът може да носи и знак, който се
                                    вижда върху таба (червено „!"), не само тон. */}
                                {marker?.badge && (
                                    <span className={styles.badge}>{marker.badge}</span>
                                )}
                            </NavLink>
                        );
                    })}
                </div>
            )}
        </div>
    );
};
